import { getAllPollenBottleTransactionType } from "@/api/pollen_bottle_transaction";

const state = {
    pollenBottleTransaction: null,
    pollenBottleTransactionTypes: null,
    pollenBottleTransactionDetail: null
};

const mutations = {
    GET_ALL: (state, data) => {
        state.pollenBottleTransaction = data;
    },
    GET_ALL_TYPE: (state, data) => {
        state.pollenBottleTransactionTypes = data;
    },
    GET_DETAIL: (state, data) => {
        state.pollenBottleTransactionDetail = data;
    },
};

const actions = {
    async getAllPollenBottleTransactionType({ commit }) {
        let res = await getAllPollenBottleTransactionType();
        if (res) {
            commit("GET_ALL_TYPE", res); 
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/pollen_bottle_transaction.js